import {makeFileUploadBody, post} from "../../utils";

export default host => (imageFile, isEditorialImage = false) =>
  post(`${host}/files/images`, makeFileUploadBody('image', imageFile, isEditorialImage))
    .then(response => response.json())
    .then(response => response.data)
